/**
 * Quote misc fees endpoints (backend OR-1421, FE OR-1494).
 *
 *   GET    /v2/submissions/:id/quote/misc-fees/
 *   POST   /v2/submissions/:id/quote/misc-fees/           body: { name?, amount? }
 *   PATCH  /v2/submissions/:id/quote/misc-fees/:miscFeeId body: { name?, amount? }
 *   DELETE /v2/submissions/:id/quote/misc-fees/:miscFeeId → 204
 *
 * POST 404s while the submission has no saved quote yet (the quote row is
 * the parent) — callers must save the quote first. The quote GET already
 * embeds the list as `misc_fees`, so `listMiscFees` is only for a targeted
 * refresh after a write.
 */
import type { MiscFee, MiscFeeWire, MiscFeeWritePayload } from "../../types/misc-fee";
import { wireToMiscFee } from "../../types/misc-fee";
import { getJsonReal, sendJsonReal } from "../client";

function miscFeesBase(submissionId: string): string {
    // Collection path keeps the trailing slash (FastAPI 307 otherwise).
    return `/v2/submissions/${encodeURIComponent(submissionId)}/quote/misc-fees`;
}

export function listMiscFees(submissionId: string): Promise<MiscFee[]> {
    return getJsonReal<MiscFeeWire[]>(`${miscFeesBase(submissionId)}/`).then((rows) => rows.map(wireToMiscFee));
}

export function createMiscFee(submissionId: string, payload: MiscFeeWritePayload): Promise<MiscFee> {
    return sendJsonReal<MiscFeeWire>(`${miscFeesBase(submissionId)}/`, "POST", payload).then(wireToMiscFee);
}

export function patchMiscFee(submissionId: string, miscFeeId: string, payload: MiscFeeWritePayload): Promise<MiscFee> {
    return sendJsonReal<MiscFeeWire>(`${miscFeesBase(submissionId)}/${encodeURIComponent(miscFeeId)}`, "PATCH", payload).then(
        wireToMiscFee,
    );
}

export function deleteMiscFee(submissionId: string, miscFeeId: string): Promise<void> {
    return sendJsonReal<void>(`${miscFeesBase(submissionId)}/${encodeURIComponent(miscFeeId)}`, "DELETE");
}
